// src/components/Book.js

import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import ShelfChanger from "./ShelfChanger"; // Import the reusable component

// Fallback for missing thumbnail
const FALLBACK_THUMBNAIL = "https://via.placeholder.com/128x193?text=No+Cover";

// Create functional component
const Book = ({ book, changeBookShelf }) => {
    const navigate = useNavigate(); // Initialize navigate hook

    const thumbnail = 
        book.imageLinks && book.imageLinks.thumbnail
            ? book.imageLinks.thumbnail
            : FALLBACK_THUMBNAIL;

    const authors = 
        book.authors && Array.isArray(book.authors)
            ? book.authors.join(", ")
            : "Author(s) Unknown";

    // Handler to navigate to the detail page on cover/title click
    const handleDetailClick = () => {
        navigate(`/book/${book.id}`);
    };

    return (
        <div className="book">
            <div className="book-top">
                <div
                    className="book-cover"
                    style={{
                        width: 128,
                        height: 193,
                        backgroundImage: `url(${thumbnail})`,
                        cursor: 'pointer', // Indicate interactivity
                    }}
                    onClick={handleDetailClick} // Navigate on cover click
                ></div>
                <div className="book-shelf-changer">
                    {/* Use the reusable component here */}
                    <ShelfChanger book={book} changeBookShelf={changeBookShelf} />
                </div>
            </div>
            {/* Make title and authors clickable as well */}
            <div className="book-title" onClick={handleDetailClick} style={{ cursor: 'pointer' }}>
                {book.title}
            </div>
            <div className="book-authors">{authors}</div> 
        </div>
    );
};

// Define a basic book shape for PropTypes
Book.propTypes = {
    book: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        authors: PropTypes.arrayOf(PropTypes.string),
        shelf: PropTypes.string,
        imageLinks: PropTypes.shape({
            thumbnail: PropTypes.string,
        }),
    }).isRequired,
    changeBookShelf: PropTypes.func.isRequired,
};

export default Book;
